export var TripFilter;
(function (TripFilter) {
    TripFilter["NO_FILTER"] = "NoFilter";
    TripFilter["AND_FILTER"] = "AndFilter";
    TripFilter["NON_STOP_FILTER"] = "NonStopFilter";
    TripFilter["SHORT_LAYOVER_FILTER"] = "ShortLayoverFilter";
    TripFilter["NO_LOW_COST_CARRIER_FILTER"] = "NoLowCostCarrierFilter";
})(TripFilter || (TripFilter = {}));
export var SliceStopCountFilter;
(function (SliceStopCountFilter) {
    SliceStopCountFilter["DEFAULT"] = "DEFAULT";
    SliceStopCountFilter["ANY_NUMBER"] = "ANY_NUMBER";
    SliceStopCountFilter["NONE"] = "NONE";
    SliceStopCountFilter["ONE_OR_LESS"] = "ONE_OR_LESS";
    SliceStopCountFilter["TWO_OR_LESS"] = "TWO_OR_LESS";
})(SliceStopCountFilter || (SliceStopCountFilter = {}));
export var FareclassShelfBrandNameMapping = {
    basic: 0,
    standard: 1,
    enhanced: 2,
    premium: 3,
    luxury: 4,
};
export var FlightShopType;
(function (FlightShopType) {
    FlightShopType["CHANGE_FOR_ANY_REASON_EXERCISE"] = "chfar-exercise";
    FlightShopType["DISRUPTION_PROTECTION_EXERCISE"] = "dp-exercise";
    FlightShopType["DEFAULT"] = "default";
})(FlightShopType || (FlightShopType = {}));
export var FLIGHT_SHOP_TYPE = "flightShopType";
export var FlightBookType;
(function (FlightBookType) {
    FlightBookType["CHANGE_FOR_ANY_REASON_EXERCISE"] = "chfar-exercise";
    FlightBookType["DISRUPTION_PROTECTION_EXERCISE"] = "dp-exercise";
    FlightBookType["DEFAULT"] = "default";
})(FlightBookType || (FlightBookType = {}));
export var FLIGHT_BOOK_TYPE = "flightBookType";
//# sourceMappingURL=constants.js.map